// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DNode, WNodeFactory, WidgetProperties } from '@dojo/framework/core/interfaces';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';
import { create, v } from '@dojo/framework/core/vdom';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { Keys, delay } from '@holmescorp/common';
import { createNlsMiddleware } from '@holmescorp/lcc-state';

import css from '../css/audio.m.css';
import { ExperimentalHTMLAudioElement } from '../interfaces';
import { AudioMiddleware } from '../middleware/audio';

export interface AudioProperties {
	audio: AudioMiddleware;
	showPlaylist?: boolean;
}

interface AudioIcache {
	player: ExperimentalHTMLAudioElement;
	loadError: boolean;
	filesLoaded: boolean;
	playerLoaded: boolean;
	currentTrack: number;
}

const icache = createICacheMiddleware<AudioIcache>();

const nls = createNlsMiddleware('audio');
const factory = create({
	icache,
	theme,
	nls
}).properties<AudioProperties>();

export const AudioPlayer = factory(({ properties, middleware: { icache, theme, nls } }) => {
	const { showPlaylist = true, audio } = properties();
	const {
		messages: { playlist_title = '[audio] playlist_title' }
	} = nls();

	const themeCss = theme.classes(css);
	const playlist = audio.get_playlist();

	const show_playlist = () => {
		const track = icache.get('currentTrack');
		const playlist_items = playlist.map((file, index) => {
			return v('li', {}, [
				v(
					'div',
					{
						id: `track-${index}`,
						role: 'button',
						tabIndex: 0,
						...formatAriaProperties({
							label: `Play ${file.title} audio`
						}),
						onclick: () => {
							audio.change_track(index);
						},
						onkeydown: (event: KeyboardEvent) => {
							switch (event.key) {
								case Keys.Enter:
								case Keys.Space:
								case Keys.Spacebar:
									event.preventDefault();
									audio.change_track(index);
									break;
							}
						},
						classes: [themeCss.playlistItem, track === index ? 'playing' : null]
					},
					[file.title]
				)
			]);
		});

		return [v('h3', { classes: [themeCss.playlistTitle] }, [playlist_title]), v('ul', {}, playlist_items)];
	};

	delay(200).then(() => {
		audio.setup_audio_player();
	});

	return playlist.length
		? v('div', { classes: [themeCss.root] }, [
				v('div', { classes: [themeCss.player] }, [v('audio-js', { id: 'audio-player' })]),
				showPlaylist ? v('div', { classes: [themeCss.playlist] }, show_playlist()) : null,
				v('div', { classes: [themeCss.clear] })
		  ])
		: [];
});

export default AudioPlayer;
